import { useTalkState } from "@mgdx/talk/providers/TalkStoreProvider";

import { useCurrentUser } from "../../hooks/useCurrentUser";
import { TalkMessageListModal } from "./TalkMessageListModal";

export const TalkMessageListApp = () => {
  const currentUser = useCurrentUser();
  const { isEnabledTalk } = useTalkState();

  if (currentUser.isLoggedIn && isEnabledTalk) {
    return <TalkMessageListModal />;
  }

  return null;
};
